import Cookie from 'js-cookie';
import {
    COOKIE_VAELG_SELV_SELECTED_CHANNELS,
    COOKIE_VAELG_SELV_SELECTED_PACKAGE,
} from '@/modules/TV/utilities/cookies';
import { InfrastructureOwner, TechnologyType } from '../models/sows';
import { CART_LOCALSTORAGE_KEY } from '@/common/stores/CartStore';
import { ACTIVE_INTERNET_CAMPAIGN_OVERRIDE } from '@/common/utilities/settings';

export const ORDER_LOCALSTORAGE_KEY = 'Stofa Order';
export const RETAIL_ORDER_SAVED_TO_GOOGLE_DOC_KEY =
    'Stofa retail order saved to google doc';
export const ADDRESS_INFO_CACHE_KEY = 'Stofa Address Info';
export const ADDRESS_DATA_CACHE_KEY = 'Stofa Address Data Cache';
export const STOFA_BAROLO_REDIRECT_URL_COOKIE = 'Stofa Barolo Redirect URL';
export const BB_PRODUCTS_CACHE_KEY = 'Stofa BB Products';
export const TV_PRODUCTS_CACHE_KEY = 'Stofa TV Products';

export const ENIIG_UUID = 'Eniig.uuid';
export const DRUPAL_COOKIE_ADDRESS_FULL = 'Drupal.visitor.address_full';
export const DRUPAL_COOKIE_SEGMENT_ID = 'Drupal.visitor.segment_id';
export const DRUPAL_COOKIE_TECHNOLOGY = 'Drupal.visitor.technology';
export const DRUPAL_COOKIE_INFRASTRUCTURE_OWNER = 'Drupal.visitor.io';

export const AFFILIATE_ADSERVICE = 'affilate_adservice';

// Clear old cache - todo: Remove
export const OLD_ADDRESS_DATA_CACHE_KEY = 'Stofa Address Data';
window.localStorage.removeItem(OLD_ADDRESS_DATA_CACHE_KEY);

export function setAddressCookies(
    dawaAddressText: string,
    technologyType: TechnologyType,
    segmentId: string,
    infrastructureOwner: InfrastructureOwner,
    uuid?: string
): void {
    Cookie.set(DRUPAL_COOKIE_ADDRESS_FULL, dawaAddressText, {
        expires: 365,
    });
    Cookie.set(DRUPAL_COOKIE_TECHNOLOGY, technologyType, {
        expires: 365,
    });
    Cookie.set(
        DRUPAL_COOKIE_SEGMENT_ID,
        infrastructureOwner === 'stofa' ? segmentId : '0',
        {
            expires: 365,
        }
    );
    Cookie.set(DRUPAL_COOKIE_INFRASTRUCTURE_OWNER, infrastructureOwner, {
        expires: 365,
    });

    if (uuid) {
        Cookie.set(ENIIG_UUID, uuid);
    }
}

export function clearAllCookiesAndLocalstorage(): void {
    Cookie.remove(ACTIVE_INTERNET_CAMPAIGN_OVERRIDE);
    Cookie.remove(DRUPAL_COOKIE_ADDRESS_FULL);
    Cookie.remove(DRUPAL_COOKIE_SEGMENT_ID);
    Cookie.remove(DRUPAL_COOKIE_TECHNOLOGY);
    Cookie.remove(DRUPAL_COOKIE_INFRASTRUCTURE_OWNER);
    Cookie.remove(STOFA_BAROLO_REDIRECT_URL_COOKIE);
    Cookie.remove(ADDRESS_INFO_CACHE_KEY);
    Cookie.remove(BB_PRODUCTS_CACHE_KEY);
    Cookie.remove(COOKIE_VAELG_SELV_SELECTED_CHANNELS);
    Cookie.remove(COOKIE_VAELG_SELV_SELECTED_PACKAGE);
    Cookie.remove(RETAIL_ORDER_SAVED_TO_GOOGLE_DOC_KEY);
    Cookie.remove(ENIIG_UUID);
    localStorage.removeItem(CART_LOCALSTORAGE_KEY);
    localStorage.removeItem(ORDER_LOCALSTORAGE_KEY);
    localStorage.removeItem(TV_PRODUCTS_CACHE_KEY);
    localStorage.removeItem(ADDRESS_DATA_CACHE_KEY);
}
